import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // ページ遷移時にスクロール位置を上部に設定
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // このコンポーネント自体は何もレンダリングしません
}

export default ScrollToTop;